import { helpers } from '../helpers.js';

var prepositions = {
    options: {
    },

    selectors: {
    },

    init: function () {
        const self = this;

        jQuery( 'h1,h2,h3,h4,h5,h6,p,li,a' ).each(function () {
            const text = jQuery( this ).html();
            const updatedText = text.replace(/(\s|^)([KSVZOAUaIiksvzoaui])\s+(?=\S)/g, '$1$2&nbsp;');

            jQuery( this ).html( updatedText );
        });
    },
}

// Export
export { prepositions };